import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { catchError, throwError } from "rxjs";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return throwError(() => error);
      }

      if (error.status === 403) {
        snackBar.open(
          "Access denied. You do not have permission for this action.",
          "Dismiss",
          {
            duration: 5000,
            panelClass: "error-snackbar",
          },
        );
        return throwError(() => error);
      }

      if (error.status === 429) {
        snackBar.open(
          "Too many requests. Please wait before trying again.",
          "Dismiss",
          {
            duration: 5000,
            panelClass: "error-snackbar",
          },
        );
        return throwError(() => error);
      }

      if (error.status >= 500) {
        snackBar.open("Server error. Please try again later.", "Dismiss", {
          duration: 5000,
          panelClass: "error-snackbar",
        });
        return throwError(() => error);
      }

      if (error.status === 0) {
        snackBar.open(
          "Unable to reach server. Check your connection.",
          "Dismiss",
          {
            duration: 5000,
            panelClass: "error-snackbar",
          },
        );
        return throwError(() => error);
      }

      return throwError(() => error);
    }),
  );
};
